import React from 'react';
import {NextSeo} from 'next-seo';
import {Footer, Navbar} from '../components';

/**
 *
 */
export default function Index() {
  return (
    <>
      <NextSeo
        title={'How others use Plunk | The Open-Source Email Platform'}
        description={'Discover how others are using Plunk to run their business on autopilot.'}
        openGraph={{
          title: 'How others use Plunk | The Open-Source Email Platform',
          description: 'Discover how others are using Plunk to run their business on autopilot.',
        }}
        additionalMetaTags={[
          {
            property: 'title',
            content: 'How others use Plunk | The Open-Source Email Platform',
          },
        ]}
      />

      <Navbar />

      <div className={'mx-auto max-w-7xl px-8 md:px-0'}>
        <main>
          <div className="relative mx-auto max-w-lg lg:max-w-4xl">
            <div className={'mb-4 flex flex-col items-center justify-center gap-y-2'}>
              <div className={'mt-9 text-center'}>
                <h1 className="text-3xl font-bold tracking-tight text-neutral-800 sm:text-5xl">How others use Plunk</h1>
                <p className="mx-auto mt-2 max-w-lg text-lg text-neutral-500">
                  Discover how others are using Plunk to run their business on autopilot.
                </p>
              </div>
            </div>

            <div className="my-16 grid gap-16 pt-12 lg:grid-cols-2 lg:gap-x-12 lg:gap-y-24">
              <div>
                <p className="flex gap-1 text-xl font-semibold text-neutral-800">
                  <svg fill="none" className={'h-7 w-7'} viewBox="0 0 24 24">
                    <path
                      fillRule="evenodd"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      d="M11.995 7.23319C10.5455 5.60999 8.12832 5.17335 6.31215 6.65972C4.49599 8.14609 4.2403 10.6312 5.66654 12.3892L11.995 18.25L18.3235 12.3892C19.7498 10.6312 19.5253 8.13046 17.6779 6.65972C15.8305 5.18899 13.4446 5.60999 11.995 7.23319Z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                  Welcome
                </p>
                <p className="mt-3 text-base text-neutral-500">
                  We all love a good welcome email. It's the first impression you make on your customers. Make it count
                  and open the door to a long-lasting relationship.
                </p>
                <div className={'my-3 flex gap-1'}>
                  <span className={'rounded-full bg-purple-100 px-4 py-1 text-sm font-semibold text-purple-900'}>
                    Marketing Actions
                  </span>
                </div>
              </div>
              <div>
                <p className="flex gap-1 text-xl font-semibold text-neutral-800">
                  <svg fill="none" className={'h-7 w-7'} viewBox="0 0 24 24">
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      d="M17.25 6.75L6.75 17.25"
                    ></path>
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      d="M6.75 6.75L17.25 17.25"
                    ></path>
                  </svg>
                  Recover
                </p>
                <p className="mt-3 text-base text-neutral-500">
                  Churn is a big problem for Saas companies. Use Plunk to send personalized emails to churned customers
                  to win them back.
                </p>
                <div className={'my-3 flex gap-1'}>
                  <span className={'rounded-full bg-purple-100 px-4 py-1 text-sm font-semibold text-purple-900'}>
                    Marketing Actions
                  </span>
                </div>
              </div>
              <div>
                <p className="flex gap-1 text-xl font-semibold text-neutral-800">
                  <svg fill="none" className={'h-7 w-7'} viewBox="0 0 24 24">
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      d="M4.75 6.75C4.75 5.64543 5.64543 4.75 6.75 4.75H17.25C18.3546 4.75 19.25 5.64543 19.25 6.75V14.25C19.25 15.3546 18.3546 16.25 17.25 16.25H14.625L12 19.25L9.375 16.25H6.75C5.64543 16.25 4.75 15.3546 4.75 14.25V6.75Z"
                    ></path>
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M9.5 11C9.5 11.2761 9.27614 11.5 9 11.5C8.72386 11.5 8.5 11.2761 8.5 11C8.5 10.7239 8.72386 10.5 9 10.5C9.27614 10.5 9.5 10.7239 9.5 11Z"
                    ></path>
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12.5 11C12.5 11.2761 12.2761 11.5 12 11.5C11.7239 11.5 11.5 11.2761 11.5 11C11.5 10.7239 11.7239 10.5 12 10.5C12.2761 10.5 12.5 10.7239 12.5 11Z"
                    ></path>
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15.5 11C15.5 11.2761 15.2761 11.5 15 11.5C14.7239 11.5 14.5 11.2761 14.5 11C14.5 10.7239 14.7239 10.5 15 10.5C15.2761 10.5 15.5 10.7239 15.5 11Z"
                    ></path>
                  </svg>
                  Feedback
                </p>
                <p className="mt-3 text-base text-neutral-500">
                  Send feedback emails to your customers after they've used your product. Gain valuable insights and
                  improve along the way.
                </p>
                <div className={'my-3 flex gap-1'}>
                  <span className={'rounded-full bg-purple-100 px-4 py-1 text-sm font-semibold text-purple-900'}>
                    Marketing Actions
                  </span>
                </div>
              </div>
              <div>
                <p className="flex gap-1 text-xl font-semibold text-neutral-800">
                  <svg fill="none" className={'h-7 w-7'} viewBox="0 0 24 24">
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      d="M18.25 7.75H5.75V16.75L4.75 19.25H19.25L18.25 16.75V7.75Z"
                    ></path>
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      d="M18.25 7.75L16.25 4.75H7.75L5.75 7.75"
                    ></path>
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      d="M9.75 10.75V11.75C9.75 12.9926 10.7574 14 12 14V14C13.2426 14 14.25 12.9926 14.25 11.75V10.75"
                    ></path>
                  </svg>
                  Gifts
                </p>
                <p className="mt-3 text-base text-neutral-500">
                  Holiday season or not, sending discounts and gifts to your customers is a great way to show them you
                  care. Use Campaigns to send promotions to your customers.
                </p>
                <div className={'my-3 flex gap-1'}>
                  <span className={'rounded-full bg-orange-100 px-4 py-1 text-sm font-semibold text-orange-900'}>
                    Campaigns
                  </span>
                </div>
              </div>
              <div>
                <p className="flex gap-1 text-xl font-semibold text-neutral-800">
                  <svg fill="none" className={'h-7 w-7'} viewBox="0 0 24 24">
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      d="M4.75 6.75C4.75 5.64543 5.64543 4.75 6.75 4.75H17.25C18.3546 4.75 19.25 5.64543 19.25 6.75V14.25C19.25 15.3546 18.3546 16.25 17.25 16.25H14.625L12 19.25L9.375 16.25H6.75C5.64543 16.25 4.75 15.3546 4.75 14.25V6.75Z"
                    ></path>
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M12 8V10"
                    ></path>
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12.5 13C12.5 13.2761 12.2761 13.5 12 13.5C11.7239 13.5 11.5 13.2761 11.5 13C11.5 12.7239 11.7239 12.5 12 12.5C12.2761 12.5 12.5 12.7239 12.5 13Z"
                    ></path>
                  </svg>
                  Convert
                </p>
                <p className="mt-3 text-base text-neutral-500">
                  Warn users about approaching limits and encourage them to upgrade to a paid plan. Increase your
                  revenue and reduce churn.
                </p>
                <div className={'my-3 flex gap-1'}>
                  <span className={'rounded-full bg-purple-100 px-4 py-1 text-sm font-semibold text-purple-900'}>
                    Marketing Actions
                  </span>
                </div>
              </div>
              <div>
                <p className="flex gap-1 text-xl font-semibold text-neutral-800">
                  <svg fill="none" className={'h-7 w-7'} viewBox="0 0 24 24">
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      d="M16.75 13.25L18 12C19.6569 10.3431 19.6569 7.65685 18 6V6C16.3431 4.34315 13.6569 4.34315 12 6L10.75 7.25"
                    ></path>
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      d="M7.25 10.75L6 12C4.34315 13.6569 4.34315 16.3431 6 18V18C7.65685 19.6569 10.3431 19.6569 12 18L13.25 16.75"
                    ></path>
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      d="M14.25 9.75L9.75 14.25"
                    ></path>
                  </svg>
                  Content
                </p>
                <p className="mt-3 text-base text-neutral-500">
                  Deliver a link to content a user bought or subscribed to. Useful for digital products and services
                  like Notion or website templates.
                </p>
                <div className={'my-3 flex gap-1'}>
                  <span className={'rounded-full bg-green-100 px-4 py-1 text-sm font-semibold text-green-900'}>
                    Transactional Actions
                  </span>
                </div>
              </div>
              <div>
                <p className="flex gap-1 text-xl font-semibold text-neutral-800">
                  <svg fill="none" className={'h-7 w-7'} viewBox="0 0 24 24">
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      d="M8.75 4.75H15.25C17.4591 4.75 19.25 6.54086 19.25 8.75V15.25C19.25 17.4591 17.4591 19.25 15.25 19.25H8.75C6.54086 19.25 4.75 17.4591 4.75 15.25V8.75C4.75 6.54086 6.54086 4.75 8.75 4.75Z"
                    ></path>
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      d="M7.75 12.75C7.75 12.75 9 15.25 12 15.25C15 15.25 16.25 12.75 16.25 12.75"
                    ></path>
                    <circle cx="14" cy="10" r="1" fill="currentColor"></circle>
                    <circle cx="10" cy="10" r="1" fill="currentColor"></circle>
                  </svg>
                  Reactivate
                </p>
                <p className="mt-3 text-base text-neutral-500">
                  Motivate users to come back to your product by sending them personalized emails. Increase your active
                  users and reduce churn.
                </p>
                <div className={'my-3 flex gap-1'}>
                  <span className={'rounded-full bg-purple-100 px-4 py-1 text-sm font-semibold text-purple-900'}>
                    Marketing Actions
                  </span>
                </div>
              </div>
              <div>
                <p className="flex gap-1 text-xl font-semibold text-neutral-800">
                  <svg fill="none" className={'h-7 w-7'} viewBox="0 0 24 24">
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      d="M5.75 10.2502H18.25C18.8023 10.2502 19.25 9.80253 19.25 9.25025V5.75C19.25 5.19772 18.8023 4.75 18.25 4.75H5.75C5.19772 4.75 4.75 5.19772 4.75 5.75V9.25025C4.75 9.80253 5.19772 10.2502 5.75 10.2502Z"
                    ></path>
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      d="M5.75 19.2502H18.25C18.8023 19.2502 19.25 18.8025 19.25 18.2502V14.75C19.25 14.1977 18.8023 13.75 18.25 13.75H5.75C5.19772 13.75 4.75 14.1977 4.75 14.75V18.2502C4.75 18.8025 5.19772 19.2502 5.75 19.2502Z"
                    ></path>
                  </svg>
                  Waitlist
                </p>
                <p className="mt-3 text-base text-neutral-500">
                  Collect emails from users who are interested in your product. Keep track of signups and engage with
                  them through campaigns.
                </p>
                <div className={'my-3 flex gap-1'}>
                  <span className={'rounded-full bg-purple-100 px-4 py-1 text-sm font-semibold text-purple-900'}>
                    Marketing Actions
                  </span>
                  <span className={'rounded-full bg-orange-100 px-4 py-1 text-sm font-semibold text-orange-900'}>
                    Campaigns
                  </span>
                </div>
              </div>
              <div>
                <p className="flex gap-1 text-xl font-semibold text-neutral-800">
                  <svg fill="none" className={'h-7 w-7'} viewBox="0 0 24 24">
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      d="M4.75 8H7.25"
                    ></path>
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      d="M12.75 8H19.25"
                    ></path>
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      d="M4.75 16H12.25"
                    ></path>
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      d="M17.75 16H19.25"
                    ></path>
                    <circle
                      cx="10"
                      cy="8"
                      r="2.25"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                    ></circle>
                    <circle
                      cx="15"
                      cy="16"
                      r="2.25"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                    ></circle>
                  </svg>
                  Updates
                </p>
                <p className="mt-3 text-base text-neutral-500">
                  Inform users about new features and updates. Increase engagement and encourage adoption of the entire
                  product.
                </p>
                <div className={'my-3 flex gap-1'}>
                  <span className={'rounded-full bg-orange-100 px-4 py-1 text-sm font-semibold text-orange-900'}>
                    Campaigns
                  </span>
                </div>
              </div>
              <div>
                <p className="flex gap-1 text-xl font-semibold text-neutral-800">
                  <svg fill="none" className={'h-7 w-7'} viewBox="0 0 24 24">
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      d="M6.75 7.75L7.59115 17.4233C7.68102 18.4568 8.54622 19.25 9.58363 19.25H14.4164C15.4538 19.25 16.319 18.4568 16.4088 17.4233L17.25 7.75"
                    ></path>
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      d="M9.75 7.5V6.75C9.75 5.64543 10.6454 4.75 11.75 4.75H12.25C13.3546 4.75 14.25 5.64543 14.25 6.75V7.5"
                    ></path>
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      d="M5 7.75H19"
                    ></path>
                  </svg>
                  Warning
                </p>
                <p className="mt-3 text-base text-neutral-500">
                  Inform users about deleted resources and allow them to recover them. Prevent data loss and increase
                  satisfaction.
                </p>
                <div className={'my-3 flex gap-1'}>
                  <span className={'rounded-full bg-green-100 px-4 py-1 text-sm font-semibold text-green-900'}>
                    Transactional Actions
                  </span>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
      <Footer />
    </>
  );
}
